import {fonts} from '../../../../theme/foundations/fonts'
import {pxToRem} from '../../../../utills/pxToRem'

export const filterButtonStyles = {
    bg: 'gray.150',
    color: 'black',
    borderRadius: 'none',
    textTransform: 'uppercase',
    display: 'flex',
    h: {base: pxToRem(23), md: pxToRem(27)},
    px: pxToRem(12),
    gap: pxToRem(8),
    fontFamily: fonts.primary
}

export const filterIconStyles = {
    flexShrink: 0,
    w: {base: pxToRem(9), md: pxToRem(12)},
    h: {base: pxToRem(9), md: pxToRem(12)}
}

export const filterTextStyles = {
    fontSize: {base: pxToRem(10), md: pxToRem(12)},
    fontWeight: '400',
    letterSpacing: pxToRem(1)
}

export const clearAllButtonStyles = {
    color: 'cav_light_input_gray',
    fontSize: {base: pxToRem(12), md: pxToRem(13)},
    fontWeight: '500',
    textDecoration: 'underline',
    ml: 2,
    pb: {base: pxToRem(8), md: pxToRem(2)},
    alignSelf: 'flex-end',
    fontFamily: fonts.primary
}
